import Axios from '../axios-instance';

const CertificateExclusionSuppliersAPI = {
  getExcludedCertificate: body => {
    return Axios.post(`/ExcludedCertificateSuppliers/get`, body).then(({ data }) => data);
  },

  insertExcludedCertificate: body => {
    return Axios.post(`/ExcludedCertificateSuppliers/insert`, body).then(({ data }) => data);
  },

  removeExcludedCertificate: body => {
    return Axios.post(`/ExcludedCertificateSuppliers/delete`, body).then(({ data }) => data);
  },

  setEndDate: body => {
    return Axios.post(`/ExcludedCertificateSuppliers/setDate`, body).then(({ data }) => data);
  },

};


export default CertificateExclusionSuppliersAPI;